<script>
import Popup from './popup.vue';
import MineOption from '../select/mineOption.vue';
import MineSelect from '../select/mineSelect.vue';
import { mapState } from 'vuex';
import Loading from '../loading.vue';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        isShowChoose: {
            type: Boolean,
            default: true,
        },
    },
    name: "invoicePopup",
    data() {
        return {
            isLoading: false,
            // 是否编辑发票
            isEditInvoice: false,
            // 详情弹窗
            isShowInvoiceDetail: false,
            detail: {
                title: '',
                type: 1,
                invoice_type: 1,
                tax_number: '',
                bank_name: '',
                bank_account: '',
                address: '',
                phone: '',
                email: '',
                is_default: 0,
            },
            titleType: [
                {
                    text: '个人或事业单位',
                    value: 1,
                    invoice_type: [
                        { text: '普通发票', value: '1' },
                    ]
                },
                {
                    text: '企业',
                    value: 2,
                    invoice_type: [
                        { text: '普通发票', value: '1' },
                        { text: '专用发票', value: '2' },
                    ]
                },
            ],
            // 移动端管理按钮
            isShowDelete: false,
        };
    },
    computed: {
        // 发票抬头列表
        ...mapState(['invoiceList']),
        // 发票列表是否全选
        isCheckAll() { 
            return this.invoiceList.length > 0 ? this.invoiceList.length == this.invoiceList.filter(v => v.isChecked).length : false;
        },
        // 发票列表是否有选中项
        isHasChecked() { 
            return this.invoiceList.findIndex(v => v.isChecked) != -1;
        },
        // 发票类型
        invoiceType() {
            const currentTitleType = this.titleType.filter(v => v.value == this.detail.type)[0];
            return currentTitleType ? currentTitleType.invoice_type : [];
        },
        // 详情 发票类型 值
        typeValue() {
            return this.invoiceType.filter((v) => v.value == this.detail.invoice_type)[0].text;
        },
    },
    components: {
        Popup,
        MineSelect,
        MineOption,
        Loading
    },
    mounted() {
        // 获取发票抬头列表
        this.$store.dispatch('getInvoiceList');
    },
    destroyed() {},
    watch: {
        'detail.type': function(newVal) {
            // 重置发票类型
            const currentTitleType = this.titleType.filter(v => v.value == newVal)[0];
            if (currentTitleType) {
                this.detail.invoice_type = currentTitleType.invoice_type[0].value;
            }
        },
        // 显示弹窗
        show: {
            immediate: true,
            handler(val) {
                if (val) {
                    // 重置选择状态
                    // 如果是选择发票抬头模式，默认选中默认抬头
                    this.$store.state.invoiceList = this.invoiceList.map(v => {
                        return {
                            ...v,
                            isChecked: this.isShowChoose ? v.is_default == 1 : false
                        }
                    });
                }
            },
        },
    },
    methods: {
        // 全选
        checkAll() { 
            this.$store.state.invoiceList = this.invoiceList.map(v => {
                return {
                    ...v,
                    isChecked: !this.isCheckAll
                }
            })
        },
        // 新建发票
        createInvoice() { 
            this.isShowInvoiceDetail = true;
            this.detail = {
                title: '',
                type: 1,
                invoice_type: 1,
                tax_number: '',
                bank_name: '',
                bank_account: '',
                address: '',
                phone: '',
                email: '',
                is_default: 0,
            }
        },
        // 编辑发票
        editInvoice(data) { 
            this.isEditInvoice = true;
            this.isShowInvoiceDetail = true;
            this.detail = { ...data };
        },
        // 删除发票
        deleteInvoice() {
            if (!this.isHasChecked) return;
            const ids = this.invoiceList.filter(v => v.isChecked).map(v => v.id).join(',');
            this.$showLoading();
            this.$store.dispatch('deleteInvoice', { ids }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '删除成功' });
                    this.$store.dispatch('getInvoiceList');
                } else {
                    this.$showToast({ text: result.msg || '删除失败，请稍后重试' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: err.message || '删除失败，请稍后重试' });
            });
        },
        // 保存发票
        saveInvoice() { 
            // 校验
            if (!this.detail.title) {
                this.$showToast({ text: '请填写发票抬头' });
                this.$refs.title.focus();
                return;
            }
            if (!this.detail.email) {
                this.$showToast({ text: '请填写邮箱' });
                this.$refs.email.focus();
                return;
            }
            // 企业抬头校验
            if (this.detail.type == 2) {
                if (!this.detail.tax_number) {
                    this.$showToast({ text: '请填写税号' });
                    this.$refs.taxCode.focus();
                    return;
                }
                if (!this.detail.bank_name) {
                    this.$showToast({ text: '请填写开户银行' });
                    this.$refs.bankName.focus();
                    return;
                }
                if (!this.detail.bank_account) {
                    this.$showToast({ text: '请填写银行账户' });
                    this.$refs.bankCode.focus();
                    return;
                }
                if (!this.detail.address) {
                    this.$showToast({ text: '请填写企业地址' });
                    this.$refs.address.focus();
                    return;
                }
                if (!this.detail.phone) {
                    this.$showToast({ text: '请填写企业电话' });
                    this.$refs.phone.focus();
                    return;
                }
            }
            // 保存到列表
            if (this.isEditInvoice) {
                // 编辑
                this.$showLoading();
                this.$store.dispatch('editInvoice', {
                    ...this.detail,
                    is_default: this.detail.is_default ? 1 : 0,
                }).then((result) => {
                    this.$hideLoading();
                    if (result.code == 100) {
                        this.$showToast({ text: '保存成功' });
                        this.isShowInvoiceDetail = false;
                        this.$store.dispatch('getInvoiceList');
                    }else {
                        this.$showToast({ text: result.msg || '保存失败，请稍后重试' });
                    }
                }).catch((err) => {
                    this.$hideLoading();
                    this.$showToast({ text: err.message || '保存失败，请稍后重试' });
                });
            } else {
                // 新建
                this.$showLoading();
                this.$store.dispatch('addInvoice', {
                    ...this.detail,
                    is_default: this.detail.is_default ? 1 : 0,
                }).then((result) => {
                    this.$hideLoading();
                    if (result.code == 100) {
                        this.$showToast({ text: '保存成功' });
                        this.isShowInvoiceDetail = false;
                        this.$store.dispatch('getInvoiceList');
                    }else {
                        this.$showToast({ text: result.msg || '保存失败，请稍后重试' });
                    }
                }).catch((err) => {
                    this.$hideLoading();
                    this.$showToast({ text: err.message || '保存失败，请稍后重试' });
                });
            }
        },
        // 设为默认抬头
        setDefaultInvoice(data) {
            if (data.is_default == 1) return;
            this.$showLoading();
            this.$store.dispatch('setDefaultInvoice', { id: data.id }).then((result) => {
                this.$hideLoading();
                if (result.code == 100) {
                    this.$showToast({ text: '设置成功' });
                    this.$store.dispatch('getInvoiceList');
                } else {
                    this.$showToast({ text: result.msg || '设置失败，请稍后重试' });
                }
            }).catch((err) => {
                this.$hideLoading();
                this.$showToast({ text: err.message || '设置失败，请稍后重试' });
            });
        },
        // 发票抬头选中
        selectInvoice(item) {
            // 如果是选择发票抬头模式，只能单选
            if (this.isShowChoose) { 
                this.$store.state.invoiceList = this.invoiceList.map(v => {
                    return {
                        ...v,
                        isChecked: v.id == item.id ? !v.isChecked : false
                    }
                });
            } else {
                item.isChecked = !item.isChecked;
            }
        },
        // 确认选择发票抬头 用于申请发票
        chooseInvoice() {
            if (!this.isHasChecked) return;
            const selectedInvoice = this.invoiceList.filter(v => v.isChecked)[0];
            // console.log('选择的发票抬头：', selectedInvoice);
            this.$emit('choose-invoice', selectedInvoice);
        },

    },
};
</script>

<template>
    <div>
        <!-- 发票抬头列表 -->
        <Popup title="抬头管理" :show="show" isShowClose @close="$emit('close')">
            <div class="loading_wrap" v-if="isLoading">
                <Loading/>
            </div>
            <p class="no_more" v-else-if="invoiceList.length == 0">你还未添加抬头</p>
            <div class="invoice_list" v-else>
                <div class="item flex align_center" v-for="(item, index) in invoiceList" :key="index">
                    <div class="checkbox only_pc" :class="{active: item.isChecked}" @click="selectInvoice(item)"></div>
                    <div class="info" @click="selectInvoice(item)">
                        <p class="name">{{ item.title }}</p>
                        <p class="text">
                            <span v-if="item.invoice_type == 1">普通发票</span>
                            <span v-if="item.invoice_type == 2">专用发票</span>
                            <span> - </span>
                            <span v-if="item.type == 1">个人或事业单位</span>
                            <span v-if="item.type == 2">企业</span>
                            <span>抬头</span>
                        </p>
                    </div>
                    <!-- pc端 -->
                    <div class="btn_group flex only_pc">
                        <div class="btn" @click="editInvoice(item)">编辑</div>
                        <div class="btn" :class="{active: item.is_default == 1}" @click="setDefaultInvoice(item)">默认抬头</div>
                    </div>
                    <!-- 移动端 -->
                    <div class="checkbox only_mobile" v-if="isShowDelete || isShowChoose" :class="{active: item.isChecked}" @click="selectInvoice(item)"></div>
                    <div class="icon only_mobile" v-else @click="editInvoice(item)"><img src="@/assets/images/icon_edit.png" alt="编辑"/></div>
                </div>
            </div>
            <!-- pc -->
            <div class="bottom btn_group flex align_center justify_between only_pc">
                <div class="l flex">
                    <template v-if="!isShowChoose">
                        <div class="check flex align_center" @click="checkAll">
                            <div class="checkbox" :class="{active: isCheckAll}"></div>
                            <div class="text">全选</div>
                        </div>
                        <div class="delete" :class="{disabled: !isHasChecked}" @click="deleteInvoice">删除抬头</div>
                    </template>
                </div>
                <div class="btn_group flex">
                    <div class="btn big" :class="{disabled: !isHasChecked}" v-if="isShowChoose" @click="chooseInvoice">确认选择</div>
                    <div class="btn big" @click="createInvoice">新建抬头</div>
                </div>
            </div>
            <!-- 移动端 -->
            <div class="btn_group flex only_mobile">
                <template v-if="isShowDelete">
                    <div class="btn" @click="isShowDelete = false">取消</div>
                    <div class="btn" :class="{disabled: !isHasChecked}" @click="deleteInvoice">删除抬头</div>
                </template>
                <template v-else>
                    <div class="btn" :class="{disabled: !isHasChecked}" v-if="isShowChoose" @click="chooseInvoice">确认选择</div>
                    <div class="btn" v-else @click="isShowDelete = true">管理</div>
                    <div class="btn" @click="createInvoice">新建抬头</div>
                </template>
            </div>
        </Popup>
        <!-- 发票详情 -->
        <Popup :title="isEditInvoice ? '修改抬头' : '新建抬头'" :show="isShowInvoiceDetail" isShowClose @close="isShowInvoiceDetail = false">
            <div class="form">
                <div class="item">
                    <p class="name">发票抬头 *</p>
                    <input type="text" placeholder="必填" ref="title" v-model="detail.title"/>
                </div>
                <div class="item">
                    <p class="name">抬头类型</p>
                    <div class="radio_group">
                        <label class="radio" v-for="(item, index) in titleType" :key="index">
                            <input type="radio" :value="item.value" v-model="detail.type"/>
                            <p class="text">{{ item.text }}</p>
                        </label>
                    </div>
                </div>
                <div class="item">
                    <p class="name">发票类型</p>
                    <MineSelect :value="detail.invoice_type">
                        <template v-slot:value>{{ typeValue }}</template>
                        <MineOption v-for="(item, index) in invoiceType" :key="index"
                        :is-active="detail.invoice_type == item.value"
                        @click="detail.invoice_type = item.value">{{ item.text }}</MineOption>
                    </MineSelect>
                </div>
                <div class="item">
                    <p class="name">邮箱 *</p>
                    <input type="text" placeholder="必填" ref="email" v-model="detail.email"/>
                </div>
                <!-- 企业抬头 -->
                <template v-if="detail.type == 2">
                    <div class="item">
                        <p class="name">税号 *</p>
                        <input type="text" placeholder="纳税人识别号或社会统一征信代码" ref="taxCode" v-model="detail.tax_number"/>
                    </div>
                    <div class="item">
                        <p class="name">开户银行 *</p>
                        <input type="text" placeholder="必填" ref="bankName" v-model="detail.bank_name"/>
                    </div>
                    <div class="item">
                        <p class="name">银行账户 *</p>
                        <input type="text" placeholder="必填" ref="bankCode" v-model="detail.bank_account"/>
                    </div>
                    <div class="item">
                        <p class="name">企业地址 *</p>
                        <input type="text" placeholder="必填" ref="address" v-model="detail.address"/>
                    </div>
                    <div class="item">
                        <p class="name">企业电话 *</p>
                        <input type="text" placeholder="必填" ref="phone" v-model="detail.phone"/>
                    </div>
                </template>
                <div class="item">
                    <p class="name">设为默认</p>
                    <div class="radio_group">
                        <label class="radio">
                            <input type="checkbox" value="1" v-model="detail.is_default"/>
                            <p class="text">设为默认后，将自动填充默认抬头及税号</p>
                        </label>
                    </div>
                </div>
                <!-- <div class="item justify_end">
                    <div class="btn" @click="isShowInvoiceDetail = false">取消</div>
                    <div class="btn">完成</div>
                </div> -->
            </div>
            <div class="bottom btn_group flex justify_end">
                <div class="btn big" @click="isShowInvoiceDetail = false">取消</div>
                <div class="btn big" @click="saveInvoice">完成</div>
            </div>
        </Popup>
    </div>
</template>

<style scoped lang="scss">
.invoice_list{
    overflow-y: auto;
    height: 4rem;
    @media screen and (max-width: 750px) {
        height: auto;
        max-height: 60vh;
    }
    .item{
        gap: .2rem;
        border-bottom: 1px solid #666;
        padding: .1rem 0;
        @media screen and (max-width: 750px) {
            border-bottom: none;
            background: #fff;
            border-radius: .1rem;
            padding: .2rem .3rem;
            margin-bottom: .2rem;
        }
        .info{
            flex: 1;
            cursor: pointer;
        }
        .name{
            font-size: .16rem;
            @media screen and (max-width: 750px) {
                font-size: .24rem;
                margin-bottom: .1rem;
            }
        }
        .text{
            font-size: .12rem;
            color: #999;
            @media screen and (max-width: 750px) {
                font-size: .22rem;
            }
        }
        .icon{
            width: .3rem;
            height: .3rem;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
.bottom{
    margin-top: .2rem;
    .l{
        gap: .2rem;
    }
    .delete{
        font-size: .16rem;
        cursor: pointer;
        &.disabled{
            // color: #bbbbbb;
            opacity: .6;
            cursor: auto;
        }
    }
    .check{
        font-size: .12rem;
        gap: .05rem;
        cursor: pointer;
        user-select: none;
    }
}
.checkbox{
    width: .12rem;
    height: .12rem;
    border: 1px solid var(--font_color);
    position: relative;
    cursor: pointer;
    @media screen and (max-width: 750px) {
        width: .3rem;
        height: .3rem;
        border-radius: .04rem;
    }
    &::after{
        content: "";
        width: 30%;
        height: 60%;
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -75%) rotate(45deg);
        display: none;
    }
    &.active{
        &::after{
            display: block;
        }
    }
}
</style>